export const SOURCE_PDF_VIEWER_HOSTS = new Set([
  'tracker.lismore.nsw.gov.au',
  'www.lismore-nsw.altitudelg.com',
  'da.ballina.nsw.gov.au',
  'datracker.ballina.nsw.gov.au',
  'datracker.byron.nsw.gov.au',
  'datracker.tweed.nsw.gov.au',
  'www.planningportal.nsw.gov.au',
  'api.apps1.nsw.gov.au',
]);

export function isSupportedSourcePdfUrl(rawUrl) {
  try {
    return SOURCE_PDF_VIEWER_HOSTS.has(new URL(rawUrl).hostname.toLowerCase());
  } catch {
    return false;
  }
}

export function positivePageNumber(value) {
  const page = Number(value);
  return Number.isFinite(page) && page > 0 ? Math.trunc(page) : null;
}

export function parseSourceDocumentTarget(rawUrl, requestedPage) {
  if (!rawUrl) return { url: null, page: positivePageNumber(requestedPage) };

  try {
    const target = new URL(rawUrl);
    if (target.protocol !== 'https:') {
      return { url: null, page: positivePageNumber(requestedPage) };
    }

    const hashPage = positivePageNumber(
      new URLSearchParams(target.hash.replace(/^#/, '')).get('page')
    );
    target.hash = '';

    return {
      url: target.toString(),
      page: positivePageNumber(requestedPage) || hashPage,
    };
  } catch {
    return { url: null, page: positivePageNumber(requestedPage) };
  }
}

export function appendSourcePage(params, page) {
  const normalizedPage = positivePageNumber(page);
  if (normalizedPage) params.set('page', String(normalizedPage));
}

export function externalSourceDocumentHref(targetUrl, page) {
  const parsed = parseSourceDocumentTarget(targetUrl, page);
  if (!parsed.url) return null;
  if (!parsed.page) return parsed.url;

  const target = new URL(parsed.url);
  target.hash = `page=${parsed.page}`;
  return target.toString();
}
